module.exports = __webpack_public_path__ + "static/media/hashtag-nft-9.81f01552.jpg";